import { AxiosError } from 'axios';
import { f7 } from 'framework7-react';
import { useState } from 'react';
import { customerInfoApi } from '@/api/customerApi';
import { chargePrepaidApi } from '@/api/prepaidApi';
import { store } from '@/config/store';
import { isPrepaidChargeRestricted } from '@/consts/prepaid';
import {
  applyPrepaidRestrictionState,
  refreshPrepaidRestrictionAfterRejectedOperation,
} from '@/hooks/usePrepaidRestrictionGuard';
import {
  HousePrepaidChargeParams,
  HousePrepaidChargeResponse,
} from '@/types/api/prepaidApi';
import { getCustomerInfoRestrictionRequest } from '@/utils/prepaidRestrictionRequest';
import { storeDispatch } from '@/utils/store';

export const useHouseprepaidCharge = (customerId: number) => {
  const [data, setDate] = useState<HousePrepaidChargeResponse['data']>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<AxiosError>();
  const chargePrepaid = async (params: HousePrepaidChargeParams) => {
    let wasCharged = false;
    try {
      f7.preloader.show();
      setIsLoading(true);
      const data = await chargePrepaidApi(params);
      wasCharged = data.data.success;
      const selectedTenantId =
        store.state.selectedTenant?.m_affiliate_id ?? null;
      const { data: customerInfo } = await customerInfoApi(
        { m_customer_id: customerId },
        { applySelectedTenant: true },
      );
      if (!customerInfo.success) {
        throw new Error('基礎情報取得に失敗');
      }
      const restrictionFlag =
        customerInfo.customer?.prepaid_charge_restriction_flg;
      const restrictionRequest = getCustomerInfoRestrictionRequest(
        customerInfo.customer,
      );
      if (!restrictionRequest) {
        throw new Error('基礎情報取得の更新順を確認できません');
      }
      await applyPrepaidRestrictionState({
        customerId,
        selectedTenantId,
        isRestricted: isPrepaidChargeRestricted(restrictionFlag),
        requestId: restrictionRequest.requestId,
      });
      await storeDispatch(
        'setCampaignsInfo',
        'campaignsInfo',
        customerInfo.campaigns ?? [],
      );
      await storeDispatch(
        'setAdvancePaymentsInfo',
        'advancePaymentsInfo',
        customerInfo.prepaids,
      );
      setDate(data.data);
      return wasCharged;
    } catch (err) {
      setError(err as AxiosError);
      await refreshPrepaidRestrictionAfterRejectedOperation(customerId);
      return wasCharged;
    } finally {
      setIsLoading(false);
      f7.preloader.hide();
    }
  };

  return {
    chargePrepaid,
    data,
    isLoading,
    error,
  };
};
